// extracted by mini-css-extract-plugin
module.exports = {"title":"group-checkbox_title__1FrIe","content":"group-checkbox_content__pVqss","checkbox":"group-checkbox_checkbox__PxqoS","checked":"group-checkbox_checked__2pkDL"};